var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeasure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.94374 16.2428L6.35795 17.657M7.20648 13.98L8.62069 15.3942M9.46922 11.7173L10.8834 13.1315M11.732 9.45458L13.1462 10.8687M13.9947 7.19183L15.4089 8.60605M16.2574 4.92909L17.6717 6.34331M3.87583 16.5891L16.6037 3.86118C17.3848 3.08013 18.6511 3.08013 19.4322 3.86118L20.1393 4.56829C20.9203 5.34934 21.281 6.71895 20.5 7.5L7.5 20.5C6.71895 21.281 5.36398 20.9056 4.58293 20.1246L3.87583 19.4175C3.09478 18.6364 3.09478 17.3701 3.87583 16.5891Z",
    stroke: "#F2F5F8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasure);
export default __webpack_public_path__ + "static/media/measure.e0faa155e2d61a670b3c592467af071c.svg";
export { ForwardRef as ReactComponent };